module.exports = __webpack_public_path__ + "static/media/honor7.95fb2840.jpg";